export default __webpack_public_path__ + "static/media/IGUBET-logo.dd94e6ea.svg";